import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import { useDispatch, useSelector } from 'react-redux';
import MfproductListTableHeader from './MfproductListTableHeader';
import MfproductListTableRow from './MfproductListTableRow';
import IconEnabled from 'core/components/layout/IconEnabled';

export default function MfproductListTable({ payload }) {

  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const {userprofileInfo} = useSelector((state)=>state.headerslice)
  
  useEffect(() => {
    setRows(payload.tableList);
  }, [payload])

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      { payload.actionList.map(actionObj=>{
         if (actionObj.role!==undefined && userprofileInfo.rolename.includes(actionObj.role) && actionObj.status !== 'Draft') {
           return <IconEnabled actionObj={actionObj}  id={rowObj.id}/>
         }
             
        return <></>})}
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        <Grid item sx={{ width: '100%', }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", maxHeight: {lg:'78vh',xs:'71vh'} }}>
              {/* <ROW CONTAINER/> */}
              <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>

              {rows.map(obj => {
                    return (
                      <>
                      <Grid item xl={3} sm={4} lg={6} xs={12} key={obj.id} sx={{ width: '100%', padding: .5,  borderRadius: '5px', height: '100%', }}>
                      < MfproductListTableRow obj={obj} getActionComponent={getActionComponent} actionList={payload.actionList} handleRowClick={handleRowClick}/>
                      </Grid>
                      {/* <Grid item lg={1} xs={12}></Grid> */}
                      </>
                    ) 
                })}
              {
                  rows.length === 0 ?
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', backgroundColor: '#fafafa' }}
                      padding={1}
                    >
                      <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>Records(s) are not added, yet.</i></Typography>
                    </Grid>
                    : <></>
                }
               </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );


}